import React, { useEffect, useState } from 'react'
import { CustomDotProps, Props, WebdoorList } from 'models/webdoor'
import {  WebdoorHome } from './webdoor.styles'

import Carousel from "react-multi-carousel"
import "react-multi-carousel/lib/styles.css"

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 1
  },
  mobile: {
    breakpoint: { max: 1023, min: 0 },
    items: 1
  }
}

const CustomDot: React.FC<CustomDotProps> = ({
  onClick,
  active,
  index,
  titles,
  onActiveChange,
}) => {
  useEffect(() => {
    if (active) {
      onActiveChange?.(index ?? 0)
    }
  }, [active, index, onActiveChange])

  return (
    <button
      type="button"
      className={active ? "active" : "inactive"}
      onClick={onClick}
    >
        <span className='label'>
            {titles[index ?? 0] ?? ''}
        </span>
        
        <span className='timeline-line'>
          <span className='timeline-pipe'></span>
        </span>
    </button>
  )
}

type WebdoorsCarouselProps = {
  webdoors: WebdoorList
  onSlideChange: (index: number) => void
}

const WebdoorsCarousel: React.FC<WebdoorsCarouselProps> = ({
  webdoors,
  onSlideChange,
}) => (
    <Carousel
        responsive={responsive}
        showDots
        infinite={true}
        autoPlay={true}
        autoPlaySpeed={5000}
        customDot={
          <CustomDot
            titles={webdoors.map(item => item.title)}
            onActiveChange={onSlideChange}
          />
        }
        >
        { webdoors.map( item => (
          <WebdoorHome.Item key={item.id}>
            <WebdoorHome.Link href={item.link} title={item.title}>
              <picture>
                <source media="(min-width: 1024px)" srcSet={item.images.desktop} />
                <source media="(min-width: 768px)" srcSet={item.images.tablet} />
                <WebdoorHome.Image src={item.images.mobile} alt={item.title} />
              </picture>
            </WebdoorHome.Link>
          </WebdoorHome.Item>
        ))}
    </Carousel>
)

export const Webdoor: React.FC<Props> = ({webdoors}) => {
    const [activeSlide, setActiveSlide] = useState(0)
    const activeWebdoor = webdoors[activeSlide] ?? webdoors[0]

    return(
        <WebdoorHome.Container>
            <WebdoorHome.Label>{activeWebdoor?.message || ''}</WebdoorHome.Label>
            <WebdoorsCarousel
              webdoors={webdoors}
              onSlideChange={setActiveSlide}
            />
        </WebdoorHome.Container>
    )
}